<template>
    <el-menu
        active-text-color="#fff"
        active-background-color="#51E1E5"
        background-color="#313A46"
        class="el-menu-vertical-demo pt-3 sidebar-menu h-100"
        default-active="1"
        :collapse="isCollapse"
        text-color="#fff"
        @open="handleOpen"
        @close="handleClose"
    >
        <div class="d-flex justify-content-center align-items-center pt-2 pb-3" v-if="!isCollapse">
            <a href="/"><img :src="logoBig" style="height: 24px"/></a>
        </div>
        <div class="d-flex justify-content-center align-items-center pe-3 ps-3 pt-2 pb-3" v-else>
            <a href="/"><img :src="logoSmall" style="height: 25px" /></a>
        </div>
        <br/>

        
        
        
        <el-menu-item index="1" @click="redirectToPage('/dashboard/my-orders')" v-if="showMyOrders">
            <el-icon><i class="fa-sharp-duotone fa-solid fa-bag-shopping"></i></el-icon>
            <span class="ms-3 pe-3">My Orders</span>
        </el-menu-item>
        <el-menu-item index="2" @click="redirectToPage('/dashboard/my-account')" v-if="showAccountDetails">
            <el-icon><i class="fa-duotone fa-solid fa-user"></i></el-icon>
            <span class="ms-3 pe-3">Account Details</span>
        </el-menu-item>
        <el-menu-item index="3" @click="redirectToPage('/dashboard/discount-codes')" v-if="showDiscountCode">
            <el-icon><i class="fa-duotone fa-solid fa-tags"></i></el-icon>
            <span class="ms-3 pe-3">Discount Code</span>
        </el-menu-item>
        <el-menu-item index="4" @click="redirectToPage('/dashboard/payment-methods')" v-if="showPaymentMethods">
            <el-icon><i class="fa-duotone fa-solid fa-credit-card"></i></el-icon>
            <span class="ms-3 pe-3">Payment Methods</span>
        </el-menu-item>
        <el-menu-item index="5" @click="redirectToPage('/dashboard/password-reset')" v-if="showResetPassword">
            <el-icon><i class="fa-sharp-duotone fa-solid fa-lock"></i></el-icon>
            <span class="ms-3 pe-3">Reset Password</span>
        </el-menu-item>
        <el-menu-item index="6" @click="redirectToPage('/dashboard/partners-customers-heatmap')" v-if="showHeatmap">
            <el-icon><i class="fa-duotone fa-solid fa-map-location-dot"></i></el-icon>
            <span class="ms-3 pe-3">Customers / Partners Map</span>
        </el-menu-item>
        <el-menu-item index="7" @click="redirectToPage('/dashboard/customer-support')">
            <el-icon><i class="fa-duotone fa-solid fa-headset"></i></el-icon>
            <span class="ms-3 pe-3">Support</span>
        </el-menu-item>
        <el-menu-item index="8" @click="logoutUser()">
            <el-icon><i class="fa-sharp-duotone fa-solid fa-left-from-bracket"></i></el-icon>
            <span class="ms-3 pe-3">Logout</span>
        </el-menu-item>
        <!-- <el-sub-menu index="2" >
            <template #title>
                <el-icon><i class="fa-sharp fa-regular fa-bag-shopping"></i></el-icon>
                <span class="ms-3 pe-3">Website Reports</span>
            </template>
            <el-menu-item index="2-1" @click="redirectToPage('/order-distrubution-tipm')">
                <el-icon><i class="fa-solid fa-globe"></i></el-icon>
                <span class="ms-3 pe-3">TIPM</span>
            </el-menu-item>
            <el-menu-item index="2-2" @click="redirectToPage('/order-distrubution-ecm')">
                <el-icon><i class="fa-solid fa-globe"></i></el-icon>
                <span class="ms-3 pe-3">ECM</span>
            </el-menu-item>
            <el-menu-item index="2-3" @click="redirectToPage('/order-distrubution-merger')">
                <el-icon><i class="fa-solid fa-globe"></i></el-icon>
                <span class="ms-3 pe-3">MERGER</span>
            </el-menu-item>
        </el-sub-menu>
        <el-menu-item index="3" @click="redirectToPage('/ticket-list')">
            <el-icon><i class="fa-sharp fa-regular fa-ticket"></i></el-icon>
            <span class="ms-3 pe-3">Tickets</span>
        </el-menu-item>
        <el-menu-item index="4" @click="redirectToPage('/reseller-applications')">
            <el-icon><i class="fa-sharp fa-regular fa-file-signature"></i></el-icon>
            <span class="ms-3 pe-3">Reseller Applications</span>
        </el-menu-item>
        <el-menu-item index="5" @click="redirectToPage('/rma-tracker')">
            <el-icon><i class="fa-sharp fa-regular fa-right-left"></i></el-icon>
            <span class="ms-3 pe-3">RMA Orders Tracker</span>
        </el-menu-item> -->
    </el-menu>
</template>


<script lang="js">
import { mapState } from 'vuex';
import Mixin from '../mixins/global.mixin'
import logoSmall from '../assets/m-logo-dark.png'
import logoBig from '../assets/maks-enterprises-logo-dark-resized.png'
import appConstants from '@/constants/app.constants';

export default {
  name: 'SideBarComponent',
  mixins: [Mixin],
  computed: mapState([
      'isCollapse',
      'currentUserSession',
  ]),
  data() {
    return {
        logoSmall: logoSmall,
        logoBig: logoBig,
        //sessionTypes: appConstants.LOGIN_TYPE,
        showHeatmap: true,
        showMyOrders: true,
        showAccountDetails: true,
        showDiscountCode: true,
        showPaymentMethods: true,
        showResetPassword: true
    }
  },
  methods: {
    
  },
  mounted () {
    switch (this.currentUserSession) {
        case appConstants.LOGIN_TYPE.PARTNER:
            this.showHeatmap = true;
            this.showMyOrders = true;
            this.showAccountDetails = true;
            this.showDiscountCode = true;
            this.showPaymentMethods = false;
            this.showResetPassword = false;
            break;
        case appConstants.LOGIN_TYPE.CUSTOMER:
            this.showHeatmap = false;
            this.showMyOrders = true;
            this.showAccountDetails = false;
            this.showDiscountCode = false;
            this.showPaymentMethods = false;
            this.showResetPassword = false;
            break;
    }
  }
}
</script>